module.exports = __webpack_public_path__ + "static/media/kc_kayak.4c33693e.jpg";